import { ValueOf } from '../utilities/types';

const ruleTypes = {
  REQUEST: 'request',
  ONGOING: 'ongoing',
} as const;

export type RuleTypes = ValueOf<typeof ruleTypes >;

export default ruleTypes;

export const ruleOverviewRuleTypes = {
  ...ruleTypes,
  BOTH: 'both',
} as const;

export type RuleOverviewRuleTypes = ValueOf<typeof ruleOverviewRuleTypes>;
